import { Component, OnInit, Compiler, ViewChild, ElementRef } from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorComponent } from '../confirm/error.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material/dialog';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';
import { HeaderCustomComponent } from '../header/headerCustom.component';

@Component({ templateUrl: './adminuser.component.html', styleUrls: ['./adminuser.component.css'] })
export class AdminUserComponent implements OnInit {

  @ViewChild('closeModel', {read: ElementRef}) closeModel: ElementRef;
   users: any = {};
   superUserForm: any;
   config: any;
   superUserInfoList: any[] = [];
   submitted = false;
   loginImageURL: any = "";
   loginUserName: any = "";
   baseURL: any = null;
   showHideModel: boolean = true;
   loading: boolean = false;
   activeUserCount: number = 0;
   inactiveUserCount: number = 0;
   towerId: any;
   towerName: any;
   superUserType: any = "";
   imageURL = "https://i0.wp.com/www.winhelponline.com/blog/wp-content/uploads/2017/12/user.png?fit=256%2C256&quality=100&ssl=1";

  constructor(private modalService: MatDialog,
    private router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    private common: Common,
    private _compiler: Compiler) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout
      return;
    }
    if (this.users && this.users.userData) {
      this.loginImageURL = this.users.userData.imageURL;
      this.loginUserName = this.users.userData.userFullName;
      this.towerId = this.users.userData.towerId;
      this.towerName = localStorage.getItem('towerName');
    }
    if (localStorage.getItem('superUserType')) {
      this.superUserType = localStorage.getItem('superUserType');
    }
    let currentDate = new Date();
    this.config = config;
    this.config.minDate = { year: currentDate.getFullYear() - 10, month: currentDate.getMonth(), day: currentDate.getDate() };
    this.config.maxDate = { year: 2099, month: 12, day: 31 };
    this.config.markDisabled = false;
    this.initUserInfo();
  }

  //initailised user form
  ngOnInit() {
    this.superUserForm = this.formBuilder.group({
      userFullName: ['', Validators.required],
      userEmail: ['', Validators.required],
      userPassword: ['', Validators.required],
      userType: new FormControl("Select Role"),
      userStatus: new FormControl("User Status"),
      imageURL: new FormControl(this.imageURL),
    });

    this.getAllSuperUsersInfo();
  }

  //reset user form
   initUserInfo() {
    this.superUserForm = this.formBuilder.group({
      userFullName: ['', Validators.required],
      userEmail: ['', Validators.required],
      userPassword: ['', Validators.required],
      userType: new FormControl("Select Role"),
      userStatus: new FormControl("User Status"),
      imageURL: new FormControl(this.imageURL),
    });
  }

  //reset user form 
  private setUpdateUserInfo(superUser) {
    this.initUserInfo();
    this.superUserForm = this.formBuilder.group({
      userFullName: new FormControl(superUser.userFullName),
      userEmail: new FormControl(superUser.userEmail),
      userPassword: new FormControl(superUser.userPassword),
      userType: new FormControl(superUser.userType),
      userStatus: new FormControl(superUser.userStatus),
      userId: new FormControl(superUser.userId),
      imageURL: new FormControl(superUser.imageURL),
    });
  }

  //Get all accounts info
  private getAllSuperUsersInfo() {
    this.loading = true;
    this.superUserInfoList = [];
    this.commonService.getSuperUserList().pipe(first()).subscribe(
      data => {
        this.superUserInfoList = data;
        this.loading = false;
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

  // Save new user profile
  private onSubmit(superUserInfo) {
    if (this.superUserForm.invalid) {
      this.submitted = true;
      return;
    } else {
      if (superUserInfo.userType == "Select User Type") {
        localStorage.setItem('errorMsg', 'Must Select User Type!');
        this.showerror();
        return;
      }
      if (this.checkUserAlreadyExits(superUserInfo.userEmail)) {
        localStorage.setItem('errorMsg', 'This user already exits!');
        this.showerror();
        return
      }
      this.loading = true;
      //set login user email
      this.commonService.saveSuperUserInfo(superUserInfo).pipe(first()).subscribe(
        data => {
          this.loading = false;
          this.superUserForm.reset();
          localStorage.setItem('errorMsg', 'Profile Added successfully!');
          this.getAllSuperUsersInfo();
          this.showerror();
        },
        error => {
          this.loading = false;
          localStorage.setItem('errorMsg', 'Must enter all the fields!');
          this.showerror();
        }
      )
    }
  }

  // update user profile 
  private updateSuperUserInfo(superUserInfo) {
    if (this.superUserForm.invalid) {
      localStorage.setItem('errorMsg', 'Please enter user information!');
      this.showerror();
      return
    }
    if (superUserInfo != null) {
      if (superUserInfo) {
        if (superUserInfo.userType == "Select User Type") {
          localStorage.setItem('errorMsg', 'Must Select User Type!');
          this.showerror();
          return;
        }
        this.loading = true;
        //set login user email
        this.commonService.updationSuperUserInfo(superUserInfo).pipe(first()).subscribe(
          data => {
            this.loading = false;
            this.getAllSuperUsersInfo();
            this.closeModels()
            localStorage.setItem('errorMsg', 'Profile updated successfully!');
            this.showerror();
          },
          error => {
            this.loading = false;
            localStorage.setItem('errorMsg', error.statusText);
            this.showerror();
          }
        )
      }
    }
  }

  // Delete user profile
  private onDeleteSubmit(userInfo) {
    this.loading = true;
    //set login user email
    this.commonService.userDeletion(userInfo).pipe(first()).subscribe(
      data => {
        this.loading = true;
        localStorage.setItem('errorMsg', 'IBU is deleted successfully!');
        localStorage.removeItem('errorMsg');
        this.showerror();
      },
      error => {
        this.loading = false;
        localStorage.setItem('errorMsg', error.statusText);
        this.showerror();
      }
    )
  }

  //check super user already exits
  private checkUserAlreadyExits(userName) {
    let isUserExits = false;
    userName = userName.toLowerCase();
    for (let i = 0; i < this.superUserInfoList.length; i++) {
      let ursName = this.superUserInfoList[i].userEmail.toLowerCase();
      if (ursName == userName) {
        isUserExits = true;
      }
    }
    return isUserExits;
  }

  //close dailog box
  private closeModels() {
    this.closeModel.nativeElement.click();
  }
  //show dailog box for user messages
  showerror() {
    // this.dialogService.addDialog(ErrorComponent, {
    //   title: 'Confirm title',
    //   message: 'Confirm message'
    // })
    const modal = this.modalService.open(ErrorComponent, {
      width: 'auto',
      data: { title: 'Confirm title', message: 'Confirm message' }
    });
  }

  //logout and forward to login page
  private logout(e, routeURL) {
    this.commonService.logout();
  }

  //forward next section
  private gotoNextPage(e, routeURL) {
    this.router.navigate([routeURL]);
  }
}
